// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2Ozi_","content":"Consent_content__1thBB","footer":"Consent_footer__2zLR4"};